import useTableVirtualizationRef from "ds/components/Table/hooks/useTableVirtualizationRef";
import Table from "ds/components/Table";
import TableWrapper from "ds/components/Table/Wrapper";

import PersonalSettingsSpacesTableBody from "./Body";
import PersonalSettingsSpacesTableHead from "./Head";

const PersonalSettingsSpacesTable = () => {
  const { tableWrapperRef, virtualizationRef } = useTableVirtualizationRef();

  return (
    <TableWrapper ref={tableWrapperRef} hasPagination={false}>
      <Table ariaLabel="Spaces">
        <PersonalSettingsSpacesTableHead />
        <PersonalSettingsSpacesTableBody tableWrapperRef={virtualizationRef} />
      </Table>
    </TableWrapper>
  );
};

export default PersonalSettingsSpacesTable;
